import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import ActivityTopBar from '../../components/ActivityTopBar/ActivityTopBar';
import './TermsOfService.css';

const TermsOfService = () => {
  const { theme } = useTheme();
  const [language, setLanguage] = useState('ar');

  const content = {
    ar: {
      title: 'شروط الاستخدام',
      welcome: 'مرحباً بكم في قوانين Amposter',
      intro: 'باستخدامك لتطبيق الويب Amposter فأنت توافق على الالتزام بالقوانين التالية:',
      rules: [
        {
          title: '1- ممنوع استخدام صورة لبنت بدون حجاب',
          desc: 'في أي مكان داخل التطبيق، سواء كان ذلك في المنشورات، الصورة الشخصية، التعليقات، أو الفيديوهات.'
        },
        {
          title: '2- ممنوع استخدام أي أغنية مخالفة',
          desc: 'ويشمل ذلك الأغاني التي تحتوي على موسيقى، كلمات سيئة، أو صوت امرأة.'
        },
        {
          title: '3- ممنوع استخدام الكلمات العاطفية',
          desc: 'مثل: (أحبك، حبيبتي، وما شابه).'
        },
        {
          title: '4- ممنوع إزعاج المستخدمين الآخرين',
          desc: 'سواء بتعليق مسيء، مضايقة، أو أي تصرف يسبب الإزعاج.'
        },
        {
          title: '5- ممنوع إساءة الاستخدام',
          desc: 'ويشمل ذلك السبام، التخريب، أو أي استخدام يسيء للتطبيق أو لمستخدميه.'
        },
        {
          title: '6- ممنوع انتحال الشخصية',
          desc: 'يُمنع استخدام اسم، صورة، أو معلومات شخص آخر بقصد التضليل.'
        },
        {
          title: '7- ممنوع نشر المعلومات الشخصية',
          desc: 'مثل أرقام الهواتف، العناوين، أو أي بيانات حساسة خاصة بك أو بغيرك.'
        },
        {
          title: '8- ممنوع نشر الإعلانات أو الروابط بدون إذن مسبق',
          desc: 'مثل الروابط المشبوهة.'
        },
        {
          title: '9- الالتزام بالأدب العام واحترام الجميع',
          desc: 'أي محتوى يخالف الأخلاق العامة أو يثير الفتن يُعد مخالفة صريحة.'
        },
        {
          title: '10- لإدارة التطبيق الحق الكامل في الحظر',
          desc: 'في حال رأت أن المحتوى مخالف للقوانين.'
        }
      ],
      footer: 'أي مخالفة لهذه القوانين قد تعرض صاحبها للتحذير، ثم الحظر في حال عدم الالتزام.',
      closing: 'معاً نصنع بيئة محترمة وممتعة للجميع ❤️'
    },
    en: {
      title: 'Terms of Service',
      welcome: 'Welcome to Amposter Rules',
      intro: 'By using Amposter Web App, you agree to comply with the following rules:',
      rules: [
        {
          title: '1- Prohibited: Using images of women without hijab',
          desc: 'Anywhere in the app, whether in posts, profile pictures, comments, or videos.'
        },
        {
          title: '2- Prohibited: Using any inappropriate music',
          desc: 'This includes songs containing music, bad words, or female voice.'
        },
        {
          title: '3- Prohibited: Using romantic words',
          desc: 'Such as: (I love you, my darling, and similar expressions).'
        },
        {
          title: '4- Prohibited: Harassing other users',
          desc: 'Whether through offensive comments, harassment, or any behavior that causes annoyance.'
        },
        {
          title: '5- Prohibited: Abuse of use',
          desc: 'This includes spam, vandalism, or any use that harms the app or its users.'
        },
        {
          title: '6- Prohibited: Identity theft',
          desc: 'Using someone else\'s name, picture, or information with the intent to deceive is prohibited.'
        },
        {
          title: '7- Prohibited: Publishing personal information',
          desc: 'Such as phone numbers, addresses, or any sensitive data belonging to you or others.'
        },
        {
          title: '8- Prohibited: Publishing ads or links without prior permission',
          desc: 'Such as suspicious links.'
        },
        {
          title: '9- Commitment to public decency and respect for everyone',
          desc: 'Any content that violates public morals or incites discord is considered a clear violation.'
        },
        {
          title: '10- The app administration has full right to ban',
          desc: 'If it sees that the content violates the rules.'
        }
      ],
      footer: 'Any violation of these rules may subject the violator to a warning, then a ban if non-compliance continues.',
      closing: 'Together we create a respectful and enjoyable environment for everyone ❤️'
    }
  };

  const currentContent = content[language];

  return (
    <div className={`terms-page ${theme === 'dark' ? 'theme-dark-space' : 'theme-light-space'}`}>
      <ActivityTopBar 
        title={currentContent.title} 
        className={theme === 'dark' ? 'theme-dark-item' : 'theme-light-item'} 
      />

      <div className="terms-content">
        <div className="language-toggle">
          <button 
            className={`lang-btn ${language === 'ar' ? 'active' : ''} ${theme === 'dark' ? 'theme-dark-item' : ''}`}
            onClick={() => setLanguage('ar')}
          >
            العربية
          </button>
          <button 
            className={`lang-btn ${language === 'en' ? 'active' : ''} ${theme === 'dark' ? 'theme-dark-item' : ''}`}
            onClick={() => setLanguage('en')}
          >
            English
          </button>
        </div>

        <div className={`terms-card ${theme === 'dark' ? 'theme-dark-item' : ''}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
          <h2>{currentContent.welcome}</h2>
          <p className="intro-text">{currentContent.intro}</p>

          <div className="rules-list">
            {currentContent.rules.map((rule, index) => (
              <div key={index} className="rule-item">
                <h3>{rule.title}</h3>
                <p>{rule.desc}</p>
              </div>
            ))}
          </div>

          <div className="footer-section">
            <p className="warning-text">{currentContent.footer}</p>
            <p className="closing-text">{currentContent.closing}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
